// extracted by mini-css-extract-plugin
export default {"textArea":"sgceX","limit":"a9Gd4"};